import React from 'react';
import { Icon, IconProps } from './Icon';

export const MoveUpRightIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon viewBox="0 0 12 12" {...props}>
      <path
        d="M10.8154 8.07499L10.8161 1.74375C10.817 1.64471 10.7776 1.55539 10.7132 1.49104M4.33357 1.59318L10.4605 1.3882C10.5596 1.38734 10.6489 1.4267 10.7132 1.49104M10.7132 1.49104L1.28516 10.9191"
        stroke="#0058A8"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </Icon>
  );
};
